<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'document'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Settings</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Settings</a></li>
                            <li class="breadcrumb-item active">Countries</li>
                        </ol>
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'document'"></app-module-menu>
                    <div class="row">
                        <div class="modal fade" id="modal-document-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('document.type') || checkService.canModify('document.type')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="onCancel()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                          <div class="form-group">
                                              <label for="title">Document Type Name</label>
                                              <input type="text" required [ngClass]="(title.invalid && (title.dirty || title.touched)) ? 'form-control is-invalid' : (title.valid)? 'form-control is-valid':'form-control'" formControlName="title" id="title" placeholder="Doc. Type Name">
                                              <div *ngIf="title.invalid && (title.dirty || title.touched)" class="invalid-feedback">
                                                  <div *ngIf="title.errors.required">Document type name is required</div>
                                              </div>
                                          </div>
                                          <div class="form-group">
                                              <label for="association">User Association</label>
                                              <select required [ngClass]="(association.invalid && (association.dirty || association.touched)) ? 'form-control is-invalid' : (association.valid)? 'form-control is-valid':'form-control'" formControlName="association" id="association">
                                                <option value="">Select One</option>
                                                <option *ngFor="let userAssociation of documentAssociation;" [value]="userAssociation.class">{{userAssociation.name}}</option>

                                                
                                              </select>
                                              <div *ngIf="association.invalid && (association.dirty || association.touched)" class="invalid-feedback">
                                                  <div *ngIf="association.errors.required">Document type association is required</div>
                                              </div>
                                          </div>
                                          <div class="form-group">
                                              <label for="scope">Scope</label>
                                              <select required [ngClass]="(scope.invalid && (scope.dirty || scope.touched)) ? 'form-control is-invalid' : (scope.valid)? 'form-control is-valid':'form-control'" formControlName="scope" id="scope">
                                                <option value="">Select One</option>
                                                <option value="all">Affects all Users</option>
                                                <option value="new">Affects new Users</option>
                                              </select>
                                              <div *ngIf="scope.invalid && (scope.dirty || scope.touched)" class="invalid-feedback">
                                                  <div *ngIf="scope.errors.required">Application scope is required</div>
                                              </div>
                                          </div>
                                          <div class="form-group">
                                              <label for="notes">Notes</label>
                                              <textarea [ngClass]="(notes.invalid && (notes.dirty || notes.touched)) ? 'form-control is-invalid' : (notes.valid)? 'form-control is-valid':'form-control'" formControlName="notes" id="notes" placeholder="Notes (Optional)"></textarea>
                                              <div *ngIf="notes.invalid && (notes.dirty || notes.touched)" class="invalid-feedback">
                                                  <div *ngIf="notes.errors.maxLength">You have exceededd the maximum length</div>
                                              </div>
                                          </div>
                                            <small>The document will be created and listed in the currently selected country</small>

                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <input type="hidden" formControlName="ref" id="ref">
                                            <button type="submit" [disabled]="!dataForm.valid || dataForm.pending || processing" (click)="onCreate()" class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" data-dismiss="modal" (click)="onCancel()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right"> 
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('document.type')" data-toggle="modal" data-target="#modal-document-form" (click)="onCancel()">
                                                    <i class="fas fa-plus"></i> Add Document Type
                                                </button>&nbsp;
                                                <a [routerLink]="['/settings/document']" class="btn btn-primary btn-sm" type="button">All</a>&nbsp;
                                                <a [routerLink]="['/settings/document/active']" class="btn btn-primary btn-sm" type="button">Active</a>&nbsp;
                                                <a [routerLink]="['/settings/document/inactive']" class="btn btn-primary btn-sm" type="button">In-Active</a>&nbsp;
                                                
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search Mail">
                                                </div>
                                                <button [routerLink]="['/adverts/Deleted']" class="btn btn-primary btn-sm" type="button"><i class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>Document Type Name</th>
                                                    <th>Association</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let documentTypeRow of documentTypeList;">
                                                  <td>{{documentTypeRow.title}}</td>
                                                  <td>{{findInObject(documentTypeRow.association)}}</td>
                                                    <td>{{documentTypeRow.country.title}}</td>
                                                    <td>
                                                        <span [class]="documentTypeRow.status.active === true ? 'badge bg-success' : documentTypeRow.status.inactive === true ? 'badge bg-warning' : 'badge bg-danger'" [innerHTML]="documentTypeRow.status.active === true ? 'Active' : documentTypeRow.status.inactive === true ? 'In-Active' : 'Deleted'"></span>
                                                    </td>
                                                    <td>{{documentTypeRow.created}}</td>
                                                    <td>{{documentTypeRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" title="Modify" *ngIf="checkService.canModify('document.type')" data-toggle="modal" data-target="#modal-document-form" (click)="getEdit(documentTypeRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" title="Activate" *ngIf="checkService.canModify('document.type')" [hidden]="documentTypeRow.status.active === true" data-toggle="modal" data-target="#modal-activate" (click)="getDataFromList(documentTypeRow.title, documentTypeRow.ref)">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-warning" title="Deactivate" *ngIf="checkService.canModify('document.type')" [hidden]="documentTypeRow.status.inactive === true" data-toggle="modal" data-target="#modal-deactivate" (click)="getDataFromList(documentTypeRow.title, documentTypeRow.ref)">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" title="Delete" *ngIf="checkService.canModify('document.type')" data-toggle="modal" data-target="#modal-delete" (click)="getDataFromList(documentTypeRow.title, documentTypeRow.ref)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="documentTypeList.length == 0">
                                                    <td colspan="7" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Document Type Name</th>
                                                    <th>Association</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Created</th>
                                                    <th>Last Modified</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                    <div class="card-footer" *ngIf="documentTypeList.length > 0">
                                        <app-pagination [url]='url' [counts]='count'(refresh)="getDocType($event)"></app-pagination>
                                    </div>
                                    <!-- /.card-footer -->
                                </div>
                            </div>
                        <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
<div class="modal fade" id="modal-activate">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Activate Doc. Type</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will activate '+docTypeName+'. Are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" (click)="changeDocTypeStatus('activate', docTypeRef)" class="btn btn-outline-light">Activate Doc. Type</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-deactivate">
      <div class="modal-dialog">
        <div class="modal-content bg-secondary">
          <div class="modal-header">
            <h4 class="modal-title">Deactivate Doc. Type</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p [innerHTML]="'This action will deactivate '+docTypeName+'. Are you sure you want to continue ?'"></p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
            <button type="button" (click)="changeDocTypeStatus('deactivate', docTypeRef)" class="btn btn-outline-light">Deactivate Doc. Type</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
<div class="modal fade" id="modal-delete">
    <div class="modal-dialog">
      <div class="modal-content bg-secondary">
        <div class="modal-header">
          <h4 class="modal-title">Delete Doc. Typee</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="'This action will remove '+docTypeName+'. This action is not reversable, are you sure you want to continue ?'"></p>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-outline-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-outline-light" (click)="deleteDocType(docTypeRef)">Delete Doc. Type</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
